// extracted by mini-css-extract-plugin
export default {"section__allforyou":"AllForYou_section__allforyou__8GF9P","allforyou":"AllForYou_allforyou__SZBKp"};